var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-grid"},[_c('div',{staticClass:"p-col-fixed p-text-right p-text-bold investment-field-name"},[_vm._v(_vm._s(_vm.header)+":")]),_c('div',{staticClass:"p-col"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }